import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/sv';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@progress/kendo-theme-material/dist/all.css';
import '../Share/styles/index.scss';
import {
  Dashboard,
  MyAssignment,
  ContactTFV,
  Logout,
  Setting,
  ManageUsers,
  Login,
  ReportQuality,
  SetNewPassword,
  TimeSheet,
  KPIDashboard,
  NotificationPage,
  ChatPage,
  ResetPassword,
  ForgotPassword,
  AITolk,
  InformationContainer,
  SSOLogin,
  AITolkUser,
} from './components';
import Translation from './components/Translation';
import { NavigationProvider } from '../Share/services/navigationService';

import { MainLayout, LoginLayout, EmptyLayout } from './layouts';
import { PrivateRoute, PublicRoute, ReportRoute } from './router';
import { NotFound, MobileApp, Version, Translate } from '../Share/components';
import { LOCAL_STORE_LANGUAGE } from '../Share/constants/localStorage';

let lang = window.localStorage.getItem(LOCAL_STORE_LANGUAGE);
switch (lang) {
  case 'en':
    lang = 'en';
    break;
  case 'se':
    lang = 'sv-SE';
    break;
  default:
    lang = 'sv-SE';
    break;
}

moment.lang(lang, {
  week: {
    dow: 1, // Monday is the first day of the week
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <PrivateRoute path="/" layout={MainLayout}>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports-dashboard',
    element: (
      <PrivateRoute path="/reports-dashboard" layout={MainLayout}>
        <KPIDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/reports/:id',
    element: <ReportRoute layout={MainLayout} />,
  },
  {
    path: '/my-assignment',
    element: (
      <PrivateRoute path="/my-assignment" layout={MainLayout}>
        <MyAssignment />
      </PrivateRoute>
    ),
  },
  {
    path: '/contact-tfv',
    element: (
      <PrivateRoute path="/contact-tfv" layout={MainLayout}>
        <ContactTFV />
      </PrivateRoute>
    ),
  },
  {
    path: '/ai-tolk',
    element: (
      <PrivateRoute path="/ai-tolk" layout={MainLayout}>
        <AITolk />
      </PrivateRoute>
    ),
  },
  {
    path: '/ai-tolk/users',
    element: (
      <PrivateRoute path="/ai-tolk/users" layout={MainLayout}>
        <AITolkUser />
      </PrivateRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <PrivateRoute path="/settings" layout={MainLayout}>
        <Setting />
      </PrivateRoute>
    ),
  },
  {
    path: '/settings/manageusers',
    element: (
      <PrivateRoute path="/settings/manageusers" layout={MainLayout}>
        <ManageUsers />
      </PrivateRoute>
    ),
  },
  {
    path: '/report-quality',
    element: (
      <PrivateRoute path="/report-quality" layout={MainLayout}>
        <ReportQuality />
      </PrivateRoute>
    ),
  },
  {
    path: '/time-sheet',
    element: (
      <PrivateRoute path="/time-sheet" layout={MainLayout}>
        <TimeSheet />
      </PrivateRoute>
    ),
  },
  {
    path: '/notifications',
    element: (
      <PrivateRoute path="/notifications" layout={MainLayout}>
        <NotificationPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/translation',
    element: (
      <PrivateRoute path="/translation" layout={MainLayout}>
        <Translation />
      </PrivateRoute>
    ),
  },
  {
    path: '/new-booking',
    element: (
      <PrivateRoute path="/new-booking" layout={MainLayout}>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/translation/new-translation',
    element: (
      <PrivateRoute path="/translation/new-translation" layout={MainLayout}>
        <Translation />
      </PrivateRoute>
    ),
  },
  {
    path: '/new-emergency-booking',
    element: (
      <PrivateRoute path="/new-emergency-booking" layout={MainLayout}>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/information',
    element: (
      <PrivateRoute path="/information" layout={MainLayout}>
        <InformationContainer />
      </PrivateRoute>
    ),
  },
  {
    path: '/mobile-app/login',
    element: <MobileApp />,
  },
  {
    path: '/logout',
    element: (
      <PublicRoute layout={MainLayout}>
        <Logout />
      </PublicRoute>
    ),
  },
  {
    path: '/login',
    element: (
      <PublicRoute layout={LoginLayout}>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: '/set-new-password',
    element: (
      <PublicRoute layout={LoginLayout}>
        <SetNewPassword />
      </PublicRoute>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <PublicRoute layout={LoginLayout}>
        <ForgotPassword />
      </PublicRoute>
    ),
  },
  {
    path: '/chat',
    element: (
      <PublicRoute layout={EmptyLayout}>
        <ChatPage />
      </PublicRoute>
    ),
  },
  // {
  //   path: '/reset-password',
  //   element: (
  //     <PublicRoute layout={LoginLayout}>
  //       <ResetPassword />
  //     </PublicRoute>
  //   ),
  // },
  {
    path: '/version',
    element: <Version />,
  },
  {
    path: '*',
    element: (
      <PrivateRoute path="*" layout={MainLayout}>
        <NotFound />
      </PrivateRoute>
    ),
  },
  {
    path: '/sso-login',
    element: (
      <PublicRoute layout={EmptyLayout}>
        <SSOLogin />
      </PublicRoute>
    ),
  }
]);

class Root extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showKPIDashboard: false };
  }

  componentDidMount() {
    document.title = Translate({ content: 'login.clientPortal' });
  }

  render() {
    return (
      <NavigationProvider router={router}>
        <RouterProvider router={router} />
      </NavigationProvider>
    );
  }
}

export default Root;
